import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const NEXT_INTELLIGENCE_ROLES = ['sundial-role:T_SPONSOR_PORTAL_BASE_USER', 'sundial-role:T_SPONSOR_NEXT_BASE_USER'];

export const nextIntelligenceApplication = {
  name: ApplicationNames.NEXT_INTELLIGENCE,
  url: envConfig.apps.nextIntelligence,
  roles: NEXT_INTELLIGENCE_ROLES,
};
